import { AxiosError, AxiosPromise } from 'axios';
import { CommonHandlers } from '../hooks';
import { isTextValidAndNotEmpty } from './nullChecks';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
} from './apiUtils';
import { ErrorType } from '../types/commonTypes';

const resolvePromise = async <T>(
    aPromise: AxiosPromise<T>,
    commonHandlers: CommonHandlers,
    successMessageText?: string,
) => {
    const {
        showSpinner,
        hideSpinner,
        errorMessage,
        setSessionTimeout,
        successMessage,
        setAppVersionMismatch,
    } = commonHandlers;
    try {
        showSpinner();
        const response = await aPromise;
        const respData = response.data;
        if (isTextValidAndNotEmpty(successMessageText)) {
            successMessage(successMessageText);
        }
        return [respData, null];
    } catch (e) {
        const error = e as AxiosError<ErrorType>;
        if (didApiCallFailDueToUnauthorizedUser(error)) {
            setSessionTimeout({
                timeout: true,
            });
        } else if (didApiCallFailDueToVersionMismatch(error)) {
            setAppVersionMismatch(true);
        } else {
            errorMessage(getErrorMessage(error));
        }
        return [null, error];
    } finally {
        hideSpinner();
    }
};

export default resolvePromise;
